import DialogConfirm from '@/components/dialogConfirm';
import React, { useCallback } from 'react';

import useDialogConfirm from '@/components/dialogConfirm/hooks/useDialogConfirm';
import { Button } from 'vkit/lib/components';

import { Colors, Size } from '@/shared/entities/types';

interface ButtonDialogInterface {
  color?: Colors;
  label?: string;
  onClick?: (...item: any) => void;
  outlined?: boolean;
  size?: Size;
  solo?: boolean;
  text: string;
  icon?: string;
  iconColor?: Colors;
  modalType?: Colors;
  disabled?: boolean;
  loading?: boolean;
  noDialogHeader?: boolean;
  dialogTextIcon?: string;
  buttonYesLabel?: string;
  buttonNoLabel?: string;
}

const ButtonDialog: React.FC<ButtonDialogInterface> = ({
  color,
  label,
  onClick,
  outlined,
  size,
  solo,
  text,
  icon,
  iconColor,
  modalType,
  disabled,
  loading,
  noDialogHeader,
  dialogTextIcon,
  buttonNoLabel,
  buttonYesLabel,
}) => {
  const {
    useTitle: useDialogConfirmTitle,
    useText: useDialogConfirmText,
    useOpen: useDialogConfirmOpen,
    useFnCallback,
    useConfirm: confirm,
  } = useDialogConfirm();

  const onConfirmAction = useCallback(
    async (...args: unknown[]): Promise<void> => {
      const canDelete = await confirm('Atenção', text);

      if (canDelete) {
        onClick?.(...args);
      }
    },
    [onClick, confirm, text],
  );

  return (
    <>
      <DialogConfirm
        fnCallback={useFnCallback}
        open={!!useDialogConfirmOpen}
        text={useDialogConfirmText}
        title={useDialogConfirmTitle}
        modalType={modalType}
        noHeader={noDialogHeader}
        textIcon={dialogTextIcon}
        buttonYesLabel={buttonYesLabel}
        buttonNoLabel={buttonNoLabel}
      />

      <div id='logout'>
        <Button
          outlined={outlined}
          solo={solo}
          color={color}
          size={size}
          label={label}
          onClick={onConfirmAction}
          icon={icon}
          iconColor={iconColor}
          disabled={disabled}
          loading={loading}
        />
      </div>
    </>
  );
};

export default ButtonDialog;
